import React, { useRef, useState, useLayoutEffect } from 'react'
import { OverlayTrigger, Popover, Modal } from 'react-bootstrap'
import { PrimaryButton } from '@mmsg/louie'

function useWindowSize() {
  const [size, setSize] = useState([0, 0])
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight])
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [])
  return size
}

const Tooltip = (props) => {
  const [width] = useWindowSize()
  const [showDialog, setShowDialog] = useState(false)
  const OnShowDialog = () => setShowDialog(true)
  const OnHideDialog = () => setShowDialog(false)
  const triggerEl = useRef(null)
  const onButtonClick = () => {
    triggerEl.current.click()
  }

  let foo = global.config.isBrandMX ? (
    <span>
      <>
        <Modal show={showDialog} onHide={OnHideDialog} centered={width > 1024}>
          <Modal.Header>
            <Modal.Title id={props.id + '.header'}>
              {props.headerText || props.header}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div id={props.id + '.text'}>{props.text}</div>
            <div className="text-center">
              <PrimaryButton
                size="sm"
                className="mt-4"
                onClick={OnHideDialog}
                id="tooltip.gotit"
              >
                Got it
              </PrimaryButton>
            </div>
          </Modal.Body>
        </Modal>
        <span onClick={OnShowDialog} id={props.id}>
          {!props.launchViaTitleText && (
            <>
              <img className="clickable" src="/images/info-icon.svg" alt="" />
            </>
          )}
          {props.launchViaTitleText && (
            <>
              <span
                id={props.id + '.header'}
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
              >
                {props.header}
              </span>
            </>
          )}
        </span>
      </>
    </span>
  ) : (
    // REMSERV TOOLTIP
    <span>
      {width > 1024 && (
        <OverlayTrigger
          trigger="click"
          key="top"
          placement="top"
          rootClose
          overlay={
            <Popover className="popover-shadow">
              <Popover.Title as="h3" style={{ color: '#000' }}>
                {props.headerText || props.header}
              </Popover.Title>
              <Popover.Content>
                {props.subHeading ? (
                  <p style={{ color: '#000' }}>
                    <strong>{props.subHeading}</strong>
                  </p>
                ) : null}
                <p style={{ color: '#000' }}>{props.text}</p>
                <PrimaryButton
                  variant="primary"
                  size="sm"
                  className="mt-4"
                  onClick={onButtonClick}
                >
                  Got it
                </PrimaryButton>
              </Popover.Content>
            </Popover>
          }
        >
          <span ref={triggerEl}>
            {!props.launchViaTitleText && (
              <>
                <img className="clickable" src="/images/info-icon.svg" alt="" />
              </>
            )}
            {props.launchViaTitleText && (
              <>
                <span className="text-underline text-dark clickable">
                  {props.header}
                </span>
              </>
            )}
          </span>
        </OverlayTrigger>
      )}

      {width <= 1024 && (
        <>
          <Modal show={showDialog} onHide={OnHideDialog}>
            <Modal.Header style={{ color: '#000' }}>
              {props.header}
            </Modal.Header>
            <Modal.Body>
              {props.subHeading ? (
                <p style={{ color: '#000' }}>
                  <strong>{props.subHeading}</strong>
                </p>
              ) : null}
              <div style={{ color: '#000' }}>{props.text}</div>
              <div className="text-center">
                <PrimaryButton
                  variant="primary"
                  size="sm"
                  className="mt-4"
                  onClick={OnHideDialog}
                >
                  Got it
                </PrimaryButton>
              </div>
            </Modal.Body>
          </Modal>
          <span onClick={OnShowDialog}>
            {!props.launchViaTitleText && (
              <>
                <img className="clickable" src="/images/info-icon.svg" alt="" />
              </>
            )}
            {props.launchViaTitleText && (
              <>
                <span className="text-underline">{props.header}</span>
              </>
            )}
          </span>
        </>
      )}
    </span>
  )

  return foo
}

export default Tooltip
